export const GET_ALL_OPERATOR_PRODUCTS = "GET_ALL_OPERATOR_PRODUCTS"
export const GET_ALL_OPERATOR_PRODUCTS_RESPONSE_SUCCESS =
  "GET_ALL_OPERATOR_PRODUCTS_RESPONSE_SUCCESS"
export const CREATE_OPERATOR_PRODUCT = "CREATE_OPERATOR_PRODUCT"
export const UPDATE_OPERATOR_PRODUCT = "UPDATE_OPERATOR_PRODUCT"
export const DELETE_OPERATOR_PRODUCT = "DELETE_OPERATOR_PRODUCT"
export const GET_SPECIFIC_OPERATOR_PRODUCTS = "GET_SPECIFIC_OPERATOR_PRODUCTS"
